import createDataSource from '@/hooks/useDataSource';
import { createFileRoute } from '@tanstack/react-router'
import { DataGrid } from 'devextreme-react';

import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { useState, useEffect } from 'react';
import { defaultGridConfig } from '@/lib/grid-config';

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/',
)({
  component: RouteComponent
})


function RouteComponent() {
  const { entity_id } = Route.useParams();

  const offset = 100; // Height offset from window height (default: 100)
  const widthOffset = 350; // Width offset from window width (default: 300)
  const [gridHeight, setGridHeight] = useState<number>(window.innerHeight - offset);
  const [gridWidth, setGridWidth] = useState<number>(window.innerWidth - widthOffset);

  // Use default grid configuration
  const gridConfig = defaultGridConfig;


  useEffect(() => {
    const handleResize = () => {
      setGridHeight(window.innerHeight - offset);
      setGridWidth(window.innerWidth - widthOffset);
    };

    window.addEventListener('resize', handleResize);

    // Set initial dimensions
    setGridHeight(window.innerHeight - offset);
    setGridWidth(window.innerWidth - widthOffset);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [offset, widthOffset]);


  const onExporting = (e: any) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      customizeCell: function (options) {
        options.excelCell.font = { name: 'Arial', size: 12 };
        options.excelCell.alignment = { horizontal: 'left' };
      }
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'relationships.xlsx');
        });
    });
  }

  const dataSource = createDataSource(`/relationships/entity-relationships/${entity_id}`);


  const cols = [
    {
      dataField: 'relationshipType',
      caption: 'Relationship Type',
      width: 150,
    },
    {
      dataField: 'name',
      caption: 'Name',
      // cellTemplate: (cellElement, cellInfo) => {
      //   cellElement.innerHTML = `${cellInfo.data.firstName} ${cellInfo.data.lastName}`;
      // }
    },
    {
      dataField: 'firstName',
      caption: 'First Name',
      visible: false,
    },
    {
      dataField: 'lastName',
      caption: 'Last Name',
      visible: false,
    },
    {
      dataField: 'phone',
      caption: 'Phone',
    },
    {
      dataField: 'email',
      caption: 'Email',
    },
    {
      dataField: 'line1',
      caption: 'Address Line 1',
    },
    {
      dataField: 'line2',
      caption: 'Address Line 2',
    },
    {
      dataField: 'city',
      caption: 'City',
    },
    {
      dataField: 'state',
      caption: 'State',
    },
    {
      dataField: 'postal',
      caption: 'Postal Code',
    }
  ];

  return <div className="h-full w-full ">
    <div style={{ width: "calc(100%-40px)", height: "98%" }} className="m-1 ">
      <DataGrid
        width={gridWidth}
        height={gridHeight}
        columns={cols}
        dataSource={dataSource}
        {...gridConfig}
        onRowDblClick={() => {
          // router.navigate({
          //   to: '/$module_id/$entity_type_id/$entity_id',
          //   params: {
          //     module_id: moduleId,
          //     entity_type_id: queryOptions.entityTypeId,
          //     entity_id: e.data.id
          //   }
          // })
        }}
        onExporting={onExporting}
        stateStoring={{
          enabled: true,
          type: 'localStorage',
          storageKey: entity_id + '-relationship-gridstate-',
        }}
      >


      </DataGrid>
    </div>
  </div>
}
